import { ajax } from '@setel/webcommon/exposes/ajax';
import { environments } from 'environments/environment';

const BASE_URL = `${environments.apiOpsBaseUrl}/api/idp`;

export interface IUserProfile {
  createdAt: Date | string;
  email: string;
  emailVerified: false;
  fullName: string;
  id: string;
  internal: boolean;
  phone: string;
  referrerCode?: string;
  registrationCompleted: boolean;
  tags: string[];
  updatedAt: Date | string;
  userId: string;
  identityNumber?: string;
  identityType?: IdentityTypesEnum | string;
  accountVerified: true;
  dateOfBirth?: Date | string;
  gender?: string;
  language?: string;
}

export enum IdentityTypesEnum {
  icNumber = 'ic_number',
  oldIcNumber = 'old_ic_number',
  passportNumber = 'passport_number',
}

export const getUserProfile = (userId: string) => {
  return ajax.get<IUserProfile>(`${BASE_URL}/profiles/${userId}`);
};
